if (typeof StatCarousel === 'undefined') {
  class StatCarousel extends HTMLElement {
    constructor() {
      super();
      this.autoplayDelay = this.hasAttribute('data-autoplay-delay')
        ? parseInt(this.getAttribute('data-autoplay-delay'), 10)
        : false;
      this.swiper = null;
    }

    connectedCallback() {
      const swiperContainer = this.querySelector('.swiper');
      if (!swiperContainer || this.swiper) return;

      whenReady('Swiper', () => {
        try {
          const prevEl = this.querySelector('[data-stat-carousel-prev]');
          const nextEl = this.querySelector('[data-stat-carousel-next]');
          const modules = [Swiper.A11y, Swiper.EffectFade];

          if (this.autoplayDelay) {
            modules.push(Swiper.Autoplay);
          }
          if (prevEl || nextEl) {
            modules.push(Swiper.Navigation);
          }

          this.swiper = new Swiper(swiperContainer, {
            a11y: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
              crossFade: true,
            },
            autoHeight: true,
            autoplay: this.autoplayDelay
              ? {
                  delay: this.autoplayDelay,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
            modules,
            navigation:
              prevEl || nextEl
                ? {
                    prevEl: prevEl || undefined,
                    nextEl: nextEl || undefined,
                  }
                : undefined,
          });
        } catch (error) {
          console.error('Failed to initialize Stat Carousel Swiper:', error);
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, false);
        this.swiper = null;
      }
    }
  }

  if (!window.customElements.get('stat-carousel')) {
    window.customElements.define('stat-carousel', StatCarousel);
  }
}
